import React, { useEffect, useState, useRef } from 'react';
import { useParams } from "react-router-dom";
import { GameContext } from '../contexts/useGameState';
import { Game } from '../types';
import SPA_REACT_APP_API_URL from '../config';
import http from '../http'
import GameContainer from './GameContainer';
import FavoriteButton from './FavoriteButton';
import RatingButton from './RatingButton';
import GameDetails from './GameDetails';
import BugButton from './BugButton';

const GamePage: React.FC = () => {
  const { author, gameString } = useParams();
  const [activeGame, setActiveGame] = useState<Game | null>(null);
  const isMountedRef = useRef(true);
  const timeoutRef = useRef<number | null>(null);

  const loadGame = async () => {
    let URL = `${SPA_REACT_APP_API_URL}/games/${author}/${gameString}`
    try {
      const response = await http.get(URL);
      setActiveGame(response.data)

      // clear any existing timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = window.setTimeout(() => {
        if (isMountedRef.current) {
          http.post(`${SPA_REACT_APP_API_URL}/games/${response.data.id}/play`)
        }
      }, 30000)
    } catch (error) {
      console.error('Failed to fetch games:', error);
    }
  }

  useEffect(() => {
    isMountedRef.current = true;
    loadGame();
    return () => {
      isMountedRef.current = false;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
    
  return (
    <GameContext.Provider value={{activeGame, setActiveGame}} >
      <div className='p-8 text-center'>
        <div className='bold text-5xl p-4'>{activeGame?.translations[0].name}</div>
        <div className='flex-row justify-center'>
          <div className='flex-column'>
            <div className='flex-row'>
              <GameContainer/>
              <GameDetails/>
            </div>
            <div className='flex-row justify-center gap-4 mt-4'>
              <FavoriteButton/>
              <RatingButton/>
              <BugButton/>
            </div>
          </div>
        </div>
      </div>
    </GameContext.Provider>
  );
};

export default GamePage;